import { useCallback, useEffect, useState } from "react";
import { api, fmtDateTime } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Loader2, RefreshCw } from "lucide-react";

const STYLE = {
  Entwurf: "bg-amber-50 text-amber-800 border-amber-300",
  Offen: "bg-blue-50 text-blue-800 border-blue-200",
  Teilbezahlt: "bg-sky-50 text-sky-800 border-sky-200",
  Bezahlt: "bg-emerald-50 text-emerald-700 border-emerald-200",
  Storniert: "bg-slate-100 text-slate-600 border-slate-300",
};

// sevDesk-Status der Rechnung (Entwurf / Offen / Teilbezahlt / Bezahlt / Storniert), live gelesen, aktualisierbar
export const RechnungSevdeskStatus = ({ order, refreshKey, onChanged }) => {
  const [st, setSt] = useState(null);
  const [loading, setLoading] = useState(false);
  const show = !!(order.sevdesk_rechnung_id || order.rechnung_storniert);

  const load = useCallback(async (manual) => {
    setLoading(true);
    try {
      const r = await api.get(`/auftraege/${order.id}/rechnung/sevdesk-status`);
      setSt(r.data);
      // Persistierten Merker am Auftrag nachziehen (z. B. Entwurfs-Hinweis), ohne Schleife
      if (r.data.erreichbar && typeof r.data.status === "number" && r.data.status !== order.sevdesk_rechnung_status) onChanged?.();
      else if (manual) onChanged?.();
    } catch { setSt({ vorhanden: true, erreichbar: false, label: "unbekannt", hinweis: "Status konnte nicht geladen werden." }); }
    finally { setLoading(false); }
  }, [order.id, order.sevdesk_rechnung_status, onChanged]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { if (show) load(false); }, [show, order.id, order.sevdesk_rechnung_id, refreshKey]);
  if (!show || !st?.vorhanden) return null;
  const title = [st.hinweis, st.geprueft_am ? `Geprüft: ${fmtDateTime(st.geprueft_am)}` : ""].filter(Boolean).join(" · ");
  return (
    <span className="inline-flex items-center gap-1" data-testid="auftrag-rechnung-sevdesk-status">
      <span className={`text-xs px-2 py-0.5 rounded border ${STYLE[st.label] || "bg-slate-50 text-slate-700 border-slate-200"}`} title={title || "Status in sevDesk"} data-testid="auftrag-rechnung-status-label" data-status={st.label}>
        sevDesk: {st.label}{st.erreichbar === false ? " (zuletzt bekannt)" : ""}
      </span>
      <Button size="icon" variant="ghost" className="h-7 w-7" onClick={() => load(true)} disabled={loading} aria-label="sevDesk-Status aktualisieren" title="sevDesk-Status aktualisieren" data-testid="auftrag-rechnung-status-refresh">
        {loading ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <RefreshCw className="w-3.5 h-3.5" />}
      </Button>
    </span>
  );
};
